import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../../shared/components/';
import { CheckStock } from '../../../../shared/services';

export default class CheckStockButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isProcessing: false,
    };
  }
  checkStock(productNumber, productId, quantity) {
    this.setState({
      isProcessing: true,
    });

    CheckStock(productNumber, productId, quantity).then(response => {
      this.setState({
        isProcessing: false,
      });
      if (this.props.onCheckStock !== undefined) { this.props.onCheckStock(response); }
    }, () => {
      // At the moment the error will be swallowed but a error handling strategy is being considered
      this.setState({
        isProcessing: false,
      });
    });
  }

  render() {
    return (
      <div className={'check-stock-button-container'}>
        {!this.state.isProcessing ?
          <Button
            customClass={'btn-check-stock-level'}
            primary
            onClick={() => this.checkStock(this.props.productNumber, this.props.productId, this.props.quantity)}
            label={this.props.label}
          /> :
          <span className={'icon icon-rs_39-loading ajax-loader'} /> }
      </div>
    );
  }
}
CheckStockButton.propTypes = {
  productNumber: PropTypes.string,
  productId: PropTypes.string,
  quantity: PropTypes.number,
  label: PropTypes.string,
  onCheckStock: PropTypes.func,
};

CheckStockButton.defaultProps = {
  productNumber: '1111111',
  productId: '22222222',
  quantity: 0,
  label: 'click me',
  onCheckStock: undefined,
};



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/CheckStockButton/CheckStockButton.js